import {
    IconBox,
    IconCurrencyBaht,
    IconInfoCircle,
    IconLock,
    IconPlayerPause,
    IconPlayerPlay,
    IconReload,
    IconSettings,
    IconShieldCheck,
    IconTag,
    IconTerminal,
    IconTrash,
} from '@tabler/icons-react';

type TablerIcon = typeof IconInfoCircle;

export interface ActivityMeta {
    Icon: TablerIcon;
    color: string;
}

const PREFIX_RULES: Array<{ prefix: string; meta: ActivityMeta }> = [
    { prefix: 'instances.start', meta: { Icon: IconPlayerPlay, color: '#10b981' } },
    { prefix: 'instances.shutdown', meta: { Icon: IconPlayerPause, color: '#f59e0b' } },
    { prefix: 'instances.reboot', meta: { Icon: IconReload, color: '#3b82f6' } },
    { prefix: 'instances.reset', meta: { Icon: IconReload, color: '#3b82f6' } },
    { prefix: 'instances.hostname.change', meta: { Icon: IconSettings, color: '#a78bfa' } },
    { prefix: 'instances.protection.', meta: { Icon: IconLock, color: '#a78bfa' } },
    { prefix: 'instances.console.open', meta: { Icon: IconTerminal, color: '#9ca3af' } },
    { prefix: 'instances.destroy', meta: { Icon: IconTrash, color: '#ef4444' } },
    { prefix: 'instances.tag.', meta: { Icon: IconTag, color: '#14b8a6' } },
    { prefix: 'backups.', meta: { Icon: IconBox, color: '#a78bfa' } },
    { prefix: 'firewall.', meta: { Icon: IconShieldCheck, color: '#3b82f6' } },
    { prefix: 'omise.charge.', meta: { Icon: IconCurrencyBaht, color: '#f59e0b' } },
];

const FALLBACK: ActivityMeta = { Icon: IconInfoCircle, color: '#9ca3af' };

export function getActivityMeta(type: string): ActivityMeta {
    for (const rule of PREFIX_RULES) {
        if (type.startsWith(rule.prefix)) return rule.meta;
    }
    return FALLBACK;
}
